import { isMatch } from 'lodash';
import { TABS_REGISTER, TABS_CHANGE } from '../actions/tabs';

function tabs(state = {}, { type, meta, payload }) {
  switch (type) {
    case TABS_REGISTER:
      return { ...state, [meta.tabs]: payload };
    case TABS_CHANGE:
      if (typeof state[meta.tabs] === 'undefined') {
        throw new Error(`There is no tabs registered with tabsId ${meta.tabs}`);
      }

      const options = { ...state[meta.tabs] };
      options.activeTab = payload;
      options.activeTabIndex = options.tabList.findIndex(tab => isMatch(payload, tab));

      if (options.activeTabIndex === -1) {
        throw new Error(`There is no tab registered as ${JSON.stringify(payload)}`);
      }

      return { ...state, [meta.tabs]: options };
    default:
      return state;
  }
}

export default tabs;
